export default {
  affiliates: [],
  affiliate: {}
}



// WEBPACK FOOTER //
// ./src/components/affiliate/store/state.js